import { api } from "./api";

const VAPID_PUBLIC_KEY =
  "BDKGG4zj6cx69S586ojtFdQ87wC-RLF_lrVp4_Vs3tl95U-pVSBTFtx40JwudstQW4bWUmK4a0QoidNObmoljwc";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export async function registerPush() {
  if (!("serviceWorker" in navigator)) return "no sw";
  if (!("PushManager" in window)) return "no pm";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
    await navigator.serviceWorker.ready;
    if (Notification.permission === "default") {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return "not granted";
    }
    let sub = await reg.pushManager.getSubscription();
    if (sub) {
      const ok = await saveSubscription(sub);
      return ok;
    }
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    const ok = await saveSubscription(sub);
    return ok;
  } catch (e) {
    return `err:${e?.message || e}`;
  }
}

async function saveSubscription(sub) {
  try {
    const data = sub.toJSON();
    await api.post("/push/subscribe", data);
    return true;
  } catch (e) {
    return false;
  }
}

export async function unregisterPush() {
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      const data = sub.toJSON();
      await api.post("/push/unsubscribe", { endpoint: data.endpoint });
      await sub.unsubscribe();
    }
    return true;
  } catch (e) {
    return false;
  }
}
